import { createApi } from "@reduxjs/toolkit/query/react";
import { StudentProfileResponseType } from "@src/pages/student/student-profile/types";
import { baseQueryWithReauth } from "@src/utils/baseQuery";
interface GetStudentProfileRequest {
  studentId: string;
  organizationId: string;
}
interface SubjectDashboardParams {
  subjectId: string;
  batchId: string;
}

export const StudentProfileApiSlice = createApi({
  reducerPath: "studentProfileApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getStudentProfileById: builder.query<
      StudentProfileResponseType,
      GetStudentProfileRequest
    >({
      query: ({ studentId, organizationId }) => ({
        url: `student?studentId=${studentId}&organizationId=${organizationId}`,
        method: "GET",
      }),
    }),
    getSubjectDashboard: builder.query<any, SubjectDashboardParams>({
      query: ({ subjectId, batchId }) => ({
        url: `student/get-subjectDashboard?subjectId=${subjectId}&batchId=${batchId}`,
        method: "GET",
      }),
    }),
    getSubjectDashboardChapterWise: builder.query<any, SubjectDashboardParams>({
      query: ({ subjectId, batchId }) => ({
        url: `student/get-subjectDashboard-chapterWise?subjectId=${subjectId}&batchId=${batchId}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useGetStudentProfileByIdQuery,
  useGetSubjectDashboardQuery,
  useGetSubjectDashboardChapterWiseQuery,
} = StudentProfileApiSlice;
